import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import { memo, useState, useEffect } from 'react';

import { NavigationItemStyled } from './styled/NavItem';

const NavItem = ({
  name, router, href, active
}) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (router.asPath === href) {
      setIsActive(true);
    }
  }, [router, href, isActive]);

  return (
    <NavigationItemStyled
      isActive={isActive || active}
      href={href}
    >
      {name}
    </NavigationItemStyled>
  );
};

const propTypes = {
  active: PropTypes.bool,
  href: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  router: PropTypes.shape({
    asPath: PropTypes.string
  }).isRequired
};

NavItem.propTypes = propTypes;

NavItem.defaultProps = {
  active: false
};

export default withRouter(memo(NavItem));
